














import {defineComponent, PropType} from "@vue/composition-api";
import FormSection from "../../../../Components/FormSection.vue";
import {ProjectEntityInterface} from "@tool/tool.types";
import BuilderSettingsForm from "@tool/Components/BuilderSettingsForm.vue";
import useBuilderStore from "@tool/store/useBuilderStore";
import useFormHelper from "@tool/Helpers/useFormHelper";
import {useToast} from "vue-toastification/composition";
import useAxios from "@tool/Helpers/useAxios";
import {useInertia} from "@tool/Helpers/useInertia";

export default defineComponent({
    components: {
        FormSection,
        BuilderSettingsForm
    },
    props: {
        project: {
            type: Object as PropType<ProjectEntityInterface>,
            required: true
        }
    },
    setup(props) {


        const {projectBuilderSettings} = useBuilderStore();
        projectBuilderSettings.value = props.project.builder_settings;

        const form = useFormHelper({});
        const toast = useToast();

        const formHandle = async () => {
            const response = await form.value.submit(() => {
                return useAxios().put<{ success: true }>(
                        route('app.project.update-builder-settings', props.project.slug),
                        projectBuilderSettings.value);
            });

            if (response.success) {
                useInertia().get(route(route().current(), route().params), {}, {
                    preserveScroll: true,
                    onSuccess() {
                        toast.success('UTM Builder Settings were successfully saved!');
                    }
                });
            }
        }

        return {
            form,
            formHandle
        }
    }
});
